// Styles
import './ProductDescription.scss';

import cn from 'classnames';
// Libs
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import Button from '@/common/components/atoms/Button/Button';
import { ReactComponent as PrevChevronIcon } from '@/materiaux/assets/icons/chevron-left.svg';

import Headline from '../Headline/Headline';
import References from '../References/References';
import {
  ProductDescriptionDefaultProps,
  ProductDescriptionPropTypes,
} from './ProductDescription.proptypes';

const ProductDescription = ({
  brand,
  className,
  codeOldCompanySku,
  complementaryDescription,
  discountClasses,
  lengthName,
  manufacturerSku,
  name,
  range,
  sku,
  isLightDisplay,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div
      className={cn(className, 'product-description')}
      data-qa-id="product-description"
    >
      {!isLightDisplay && (
        <Button
          className="product-description__back"
          buttonSize="large"
          context="customize"
          onClick={history.goBack}
          variant="button--with-icon"
        >
          <PrevChevronIcon className="icon" />
          {t('common:messages:actions.back')}
        </Button>
      )}
      <References
        className="product-description__references"
        codeOldCompanySku={codeOldCompanySku}
        brand={brand?.name}
        discountClasses={discountClasses}
        manufacturerSku={manufacturerSku}
        sku={sku}
        isLightDisplay={isLightDisplay}
      />
      <Headline
        brand={brand}
        className="product-description__headline"
        complementaryDescription={complementaryDescription}
        lengthName={lengthName}
        name={name}
        range={range}
      />
    </div>
  );
};

ProductDescription.defaultProps = {
  ...ProductDescriptionDefaultProps,
};

ProductDescription.propTypes = {
  ...ProductDescriptionPropTypes,
};

export default ProductDescription;
